import { SCENE_CLASSES } from '../../constants/classNames';

const GRADUATION_MARKS = [174, 188, 202];

/**
 * The beaker on the table. Its liquid colour fades to the reaction's colour.
 */
export default function Beaker({ liquidColor }) {
  return (
    <g className={SCENE_CLASSES.beaker}>
      <path
        className={SCENE_CLASSES.beakerLiquid}
        d="M209 184 H271 V214 q0 8 -8 8 H217 q-8 0 -8 -8 Z"
        style={{ fill: liquidColor }}
      />
      <path
        d="M206 158 V214 q0 10 10 10 H264 q10 0 10 -10 V158"
        fill="rgba(255,255,255,0.3)"
        stroke="#5b7fa8"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M200 158 H280" stroke="#5b7fa8" strokeWidth="3" strokeLinecap="round" />
      {GRADUATION_MARKS.map((markY) => (
        <path key={markY} d={`M262 ${markY} H272`} stroke="#5b7fa8" strokeWidth="2" strokeLinecap="round" />
      ))}
      <path d="M214 166 V206" stroke="#ffffff" strokeWidth="4" strokeLinecap="round" opacity="0.6" />
    </g>
  );
}
